import { useEffect, useRef } from "react";

const Loading = () => {
  const loaderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const elem = loaderRef.current;
    if (!elem) return;

    // Show loader with fade-in
    elem.style.opacity = "0";
    elem.style.display = "flex";
    elem.style.transition = "opacity 0.3s ease-in-out";
    document.body.classList.add("no-scroll");

    requestAnimationFrame(() => {
      elem.style.opacity = "1";
    });

    return () => {
      if (!elem) return;
      // Fade-out
      elem.style.opacity = "0";
      setTimeout(() => {
        elem.style.display = "none";
        document.body.classList.remove("no-scroll");
      }, 300);
    };
  }, []);

  const loaderStyle: React.CSSProperties = {
    opacity: 0,
    display: "none",
    scrollBehavior: "unset",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    zIndex: 100,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  // Spinner styles
  const spinnerStyle: React.CSSProperties = {
    margin: "0 auto",
    width: "50px",
    height: "50px",
    position: "relative",
    backgroundImage: `
      radial-gradient(farthest-side, #03c799 92%, transparent) 50% 0,
      radial-gradient(farthest-side, #03c799 92%, transparent) 50% 100%,
      radial-gradient(farthest-side, #03c799 92%, transparent) 100% 50%,
      radial-gradient(farthest-side, #03c799 92%, transparent) 0 50%
    `,
    backgroundSize: "10px 10px",
    backgroundRepeat: "no-repeat",
    animation: "spin 0.6s linear infinite",
  };

  const innerCircleStyle: React.CSSProperties = {
    position: "absolute",
    inset: 0,
    margin: "3px",
    borderRadius: "50%",
    background:
      "repeating-conic-gradient(transparent 0 35deg, #03c799 0 90deg)",
    WebkitMask:
      "radial-gradient(farthest-side, transparent calc(100% - 3px), black 0)",
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            100% { transform: rotate(0.5turn); }
          }
        `}
      </style>
      <div
        ref={loaderRef}
        className="loader fixed top-0 left-0 w-full h-full bg-white z-[100] flex items-center justify-center"
        style={loaderStyle}
      >
        <div className="p-4 text-center">
          {/* Spinning loader */}
          <div style={spinnerStyle}>
            <div style={innerCircleStyle}></div>
          </div>
          <h2 className="my-3 font-semibold text-lg">Loading..</h2>
          <p className="mb-0 text-sm text-gray-600">
            Please wait while we get your information from the web
          </p>
        </div>
      </div>
    </>
  );
};

export default Loading;
